//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_GREEN = {
    color: [
        'var(--ods-green-1, #0A6E31)',
        'var(--ods-green-2, #27A971)',
        'var(--ods-green-3, #84D5AF)',
        'var(--ods-green-4, #198C51)',
        'var(--ods-green-5, #50BE87)',
        'var(--ods-green-6, #B8EBD6)',
    ],
};
